<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="data?.action?.id ? 'Edit Action' : 'Add Action'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!form.valid || !form.dirty"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
@if (data && data.action) {
  <div crucibleDialogContent [formGroup]="form">
    <div class="add-margin">
      <div>
        <mat-form-field class="description-field full-width">
          <mat-label>Action Description</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </div>
    </div>
    @if (data.moveList.length > 0) {
      <div class="add-margin">
        <div>
          <mat-form-field class="button-margins full-width">
            <mat-label>Move {{ form.controls['moveNumber'].value }}</mat-label>
            <mat-select placeholder="Move" formControlName="moveNumber">
              @if (!data.action.id && data.moveList.length > 1) {
                <mat-option value="{{ data.allMovesValue }}">All Moves</mat-option>
              }
              @for (move of data.moveList; track move) {
                <mat-option [value]="move.moveNumber.toString()">
                  {{ move.moveNumber }} - {{ move.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    @if (data.teamList.length > 0) {
      <div class="add-margin">
        <div>
          <mat-form-field class="button-margins full-width">
            <mat-label>Team</mat-label>
            <mat-select placeholder="Team" formControlName="teamId">
              @if (!data.action.id && data.teamList.length > 1) {
                <mat-option value="">All Teams</mat-option>
              }
              @for (team of data.teamList; track team) {
                <mat-option [value]="team.id">
                  {{ team.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
  </div>
}
</crucible-dialog>
